

































import { Vue, Component, Prop } from "vue-property-decorator";

// Types

@Component
export default class PromotionTags extends Vue {
  // Props
  @Prop({ required: true })
  public items!: string[];

  @Prop({ default: "" })
  public label!: string;

  public readMore = false;

  public get useAllItems() {
    return this.$_.isEmpty(this.items);
  }

  public get itemsList() {
    if (!this.readMore && !!this.items.length) return this.items.slice(0, 3);
    return this.items;
  }

  public get moreCount() {
    return this.items.length - 3;
  }

  public get hasMoreItems() {
    return this.items.length > 3 && !this.readMore;
  }
}
